import gql from 'graphql-tag';

export default gql`
  mutation EditMyDetails(
    $agency: String
    $agencyEmail: String
    $agencyWeb: String
    $name: String
    $lastname: String
    $biography: String
    $website: String
    $nationality: String
    $birthday: Date
    $profession: String
    $specialty: String
    $facebook: String
    $twitter: String
    $linkedin: String
    $youtube: String
    $soundcloud: String
    $cv: FilesUrlInput
    $images: [UserImageInput]
    $formal_education: [TitleRangeDatesInput]
    $informal_education: [TitleRangeDatesInput]
    $support: [TitleRangeDatesInput]
    $work_experience: [WorkExperienceInput]
    $achievements: [TitleDateInput]
    $clips: [UserImageInput]
    $videos: [FilesUrlInput]
    $interests: [String]
    $showAge: Boolean
  ) {
    editMyDetails(
      agency: $agency
      agencyEmail: $agencyEmail
      agencyWeb: $agencyWeb
      name: $name
      lastname: $lastname
      biography: $biography
      website: $website
      nationality: $nationality
      birthday: $birthday
      profession: $profession
      specialty: $specialty
      facebook: $facebook
      twitter: $twitter
      linkedin: $linkedin
      youtube: $youtube
      soundcloud: $soundcloud
      cv: $cv
      images: $images
      formal_education: $formal_education
      informal_education: $informal_education
      support: $support
      work_experience: $work_experience
      achievements: $achievements
      clips: $clips
      videos: $videos
      interests: $interests
      showAge: $showAge
    ) {
      id
    }
  }
`;



// WEBPACK FOOTER //
// ./src/graphql/EditMyDetails.js